import { render, staticRenderFns } from "./AssumptionsResidential.vue?vue&type=template&id=2d174574&scoped=true&"
import script from "./AssumptionsResidential.vue?vue&type=script&lang=js&"
export * from "./AssumptionsResidential.vue?vue&type=script&lang=js&"
import style0 from "./AssumptionsResidential.vue?vue&type=style&index=0&id=2d174574&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d174574",
  null
  
)

export default component.exports